<app-top-header class="top-bar-container" [bgStyle]="'solid'" screenTitle="Terms and Conditions"></app-top-header>
<div class="page-content m-8">
    <div iknLoader [isActive]='isLoading' class="loader-container"></div>
    <div class="m-t-20"></div>
    <div [innerHTML]="terms|iknLocalized"></div>
</div>
<app-footer></app-footer>
